export const CAMERA_CHROMES = ['metal', 'minimal', 'fill']
export const CAMERA_CHROME_ALIASES = { default: 'metal' }
export const DEFAULT_CAMERA_CHROME = 'metal'

export function resolveCameraChrome(...candidates) {
  for (const raw of candidates) {
    if (raw == null) continue
    const value = String(raw).trim().toLowerCase()
    const resolved = CAMERA_CHROME_ALIASES[value] || value
    if (CAMERA_CHROMES.includes(resolved)) return resolved
  }
  return DEFAULT_CAMERA_CHROME
}
